import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
    plBrokerageCommission: {
        id: 'quoteandbind.views.ppl.quote.Brokerage Commission',
        defaultMessage: 'Brokerage Commission',
    },
    plMimimumRetainedPremium: {
        id: 'quoteandbind.views.ppl.quote.Minimum Retained Premium',
        defaultMessage: 'Minimum Retained Premium',
    },
    policyfees: {
        id: 'quoteandbind.views.ppl.quote.Policy Fee',
        defaultMessage: 'Policy Fee'
    }, 
    infees: {
        id: 'quoteandbind.views.ppl.quote.Inspection Fee',
        defaultMessage: 'Inspection Fee'
    }, 
    exfees: {
        id: 'quoteandbind.views.ppl.quote.Extension Fee',
        defaultMessage: 'Extension Fee'
    },
    covAccordion: {
        id: 'quoteandbind.views.ppl.quote.Coverages',
        defaultMessage: 'Coverages'
    }
});
